import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function exportPurchasePaymentsToPDF(payments, filename = "purchase_payments.pdf") {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let currentY = 10;

  doc.setProperties({
    title: "Purchase Payment Report",
    subject: "Purchase Payment Data Export",
    creator: "Afghan Cosmos Group",
  });

  // Helper function to handle currency values
  const firstCurrencyValue = (obj) => {
    if (obj && typeof obj === "object") {
      const firstEntry = Object.values(obj)[0];
      if (firstEntry && typeof firstEntry === "object")
        return firstEntry.source ?? "-";
      return firstEntry ?? "-";
    }
    return obj ?? "-";
  };

  // --- HEADER ---
  const addHeader = () => {
    const shopName = "Afghan Cosmos ";

    try {
      const logoUrl = `${process.env.REACT_APP_IMAGE_URL}images/logo.jpeg`;
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = logoUrl;
      doc.addImage(img, "JPEG", pageWidth - 25, 2, 15, 10);

    } catch (error) {
      console.error("Failed to load logo:", error);
    }

    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(51, 102, 204);
    doc.text("Purchase Payment Report", pageWidth / 2, 9, { align: "center" });

    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(80, 80, 80);
    doc.text(shopName, 10, 7);

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated: ${new Date().toLocaleDateString()}`, 10, 11);

    return 18;
  };

  currentY = addHeader();

  // Calculate summary totals
  const summaryTotals = payments.reduce((acc, payment) => {
    const amount = parseFloat(payment.amount) || 0;
    const totalRemained = parseFloat(firstCurrencyValue(payment.total_remained_amount)) || 0;
    
    return {
      totalAmount: acc.totalAmount + amount,
      totalRemained: acc.totalRemained + totalRemained,
      currency: payment.currency || acc.currency || "AF"
    };
  }, { totalAmount: 0, totalRemained: 0, currency: "AF" });

  // --- PURCHASE PAYMENTS TABLE ---
  autoTable(doc, {
    head: [["ID", "Supplier", "Purchase Ref", "Amount", "Currency", "Payment Date", "Total Remained"]],
    body: payments.map((payment) => {
      const currency = payment.currency || "AF";
      const supplier = payment.supplier_name || "-";
      const purchaseRef = payment.purchase_reference || "-";
      const paymentDate = payment.payment_date 
        ? new Date(payment.payment_date).toLocaleString()
        : payment.created_at
        ? new Date(payment.created_at).toLocaleString()
        : "-";
      const remainedAmount = firstCurrencyValue(payment.total_remained_amount) || "0";
      
      return [
        payment.id,
        supplier,
        purchaseRef,
        payment.amount || "0.00",
        currency,
        paymentDate,
        `${remainedAmount} ${currency}`,
      ];
    }),
    startY: currentY,
    styles: {
      fontSize: 8,
      cellPadding: 2,
      halign: "center",
      valign: "middle",
      lineColor: [220, 220, 220],
      lineWidth: 0.1,
    },
    headStyles: {
      fontSize: 8,
      fontStyle: "bold",
      fillColor: [51, 102, 204],
      textColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: [245, 245, 250],
    },
    margin: { top: 2, bottom: 2, left: 3, right: 3 },
    didDrawPage: function (data) {
      if (data.pageNumber > 1) currentY = addHeader();
    },
  });

  currentY = doc.lastAutoTable.finalY + 5;

  // Add summary table
  if (currentY > pageHeight - 40) {
    doc.addPage();
    currentY = addHeader();
  }

  autoTable(doc, {
    head: [["Summary", "Total Amount", "Total Remained"]],
    body: [[
      "TOTALS",
      `${summaryTotals.totalAmount.toFixed(2)} ${summaryTotals.currency}`,
      `${summaryTotals.totalRemained.toFixed(2)} ${summaryTotals.currency}`
    ]],
    startY: currentY,
    styles: {
      fontSize: 9,
      cellPadding: 3,
      halign: "center",
      fontStyle: "bold",
    },
    headStyles: {
      fontSize: 10,
      fontStyle: "bold",
      fillColor: [51, 102, 204],
      textColor: [255, 255, 255],
    },
    bodyStyles: {
      fillColor: [245, 245, 245],
      fontStyle: "bold",
    },
    margin: { left: 3, right: 3 },
  });

  // --- FOOTER ---
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);

    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(0, pageHeight - 11, pageWidth, pageHeight - 11);

    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("تجزوی هول سیل", pageWidth / 2, pageHeight - 5, {
      align: "center",
    });

    doc.setFontSize(7);
    doc.setTextColor(150, 150, 150);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - 15, pageHeight - 5, {
      align: "right",
    });
  }

  doc.save(filename);
}